import {
  ParagraphText,
  ParagraphTextImage,
  ParagraphImage,
  ParagraphTestimonial,
  ParagraphMultipleParagraphs,
  ParagraphWebformReference,
  ParagraphBlockReference,
  ParagraphFAQ,
  ParagraphAudio,
  ParagraphVideo,
} from '../implementations';

const mappers = {
  text: ParagraphText,
  text_image: ParagraphTextImage,
  image: ParagraphImage,
  testimonial: ParagraphTestimonial,
  multiple_paragraphs: ParagraphMultipleParagraphs,
  webform_reference: ParagraphWebformReference,
  block_reference: ParagraphBlockReference,
  faq: ParagraphFAQ,
  audio: ParagraphAudio,
  video: ParagraphVideo,
};

export default mappers;
